export const SET_IS_SHOW_PRECINCT_EXPLORE_DETAIL =
  'SET_IS_SHOW_PRECINCT_EXPLORE_DETAIL';
export const GET_CUSTOMER_PREFERENCE = 'GET_CUSTOMER_PREFERENCE';
export const SET_IS_SHOW_REPLAY_VIDEO = 'SET_IS_SHOW_REPLAY_VIDEO';
